'use client';

import ExploreProductAccordion from '@/components/products/ExploreProductAccordion/ExploreProductAccordion';
import SectionContainer from '@/components/shared/SectionContainer';
import { Flex } from '@skin-seoul/design-system';
import SectionHeader from '../../components/SectionHeader';
const ExploreProductsSection = () => {
  return <SectionContainer containerInnerProps={{
    flexDirection: 'column',
    gap: 6
  }} data-sentry-element="SectionContainer" data-sentry-component="ExploreProductsSection" data-sentry-source-file="ExploreProductsSection.tsx">
      <Flex asChild alignItems="center" gap={4} width={{
      base: '100%',
      tablet: 'fit-content'
    }} justify={{
      base: 'space-between',
      tablet: 'start'
    }} data-sentry-element="Flex" data-sentry-source-file="ExploreProductsSection.tsx">
        <SectionHeader href="/shop/" title="Explore Our Products" data-sentry-element="SectionHeader" data-sentry-source-file="ExploreProductsSection.tsx" />
      </Flex>

      <ExploreProductAccordion data-sentry-element="ExploreProductAccordion" data-sentry-source-file="ExploreProductsSection.tsx" />
    </SectionContainer>;
};
export default ExploreProductsSection;